export { ConfirmModal } from './ConfirmModal';
export type { ConfirmModalProps } from './ConfirmModal.types';
